import {NgModule} from '@angular/core';
import {SocialsComponent} from './socials.component';
import {InlineSVGModule} from "ng-inline-svg-2";
import {NgClass, NgForOf, NgIf} from "@angular/common";

@NgModule({
    declarations: [
        SocialsComponent
    ],
    exports: [
        SocialsComponent
    ],
    imports: [
        InlineSVGModule,
        NgClass,
        NgIf,
        NgForOf,
    ]
})
export class SocialsModule {
}
